import { recapRank } from '@/mocks/homeContent';

const statTone: Record<string, string> = {
  实锤: 'bg-primary-100 text-primary-800',
  多源印证: 'bg-accent-100 text-accent-900',
  存疑中: 'bg-secondary-200 text-secondary-900',
  持续更新: 'bg-secondary-200 text-secondary-900',
  深读: 'bg-background-200 text-foreground-700',
};

export default function RecapRank() {
  return (
    <section id="黑料盘点" className="bg-background-50">
      <div className="mx-auto max-w-[1240px] px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-stack-line flex h-5 w-5 items-center justify-center" />
              </span>
              <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">黑料盘点</h2>
              <span className="rounded-full bg-accent-100 px-2.5 py-1 text-xs font-bold text-accent-900">季榜归档</span>
            </div>
            <p className="mt-2 text-sm text-foreground-600">把同一主题的散料攒成能一口气读完的榜单，按核实状态分级</p>
          </div>
          <a href="#专题话题" className="flex items-center gap-1 whitespace-nowrap text-sm font-bold text-primary-600 transition hover:text-primary-700">
            查看全部榜单 <i className="ri-arrow-right-line flex h-4 w-4 items-center justify-center" />
          </a>
        </div>

        <div className="overflow-hidden rounded-xl bg-background-100 ring-1 ring-background-200">
          {recapRank.map((r, i) => (
            <a
              key={r.no}
              href="#专题话题"
              className={`group flex flex-col gap-3 p-4 transition hover:bg-background-50 sm:flex-row sm:items-center sm:gap-5 md:p-5 ${
                i !== recapRank.length - 1 ? 'border-b border-background-200' : ''
              }`}
            >
              <span
                className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-lg font-label text-2xl ${
                  r.no === 1 ? 'bg-accent-500 text-foreground-950' : r.no === 2 ? 'bg-secondary-300 text-secondary-900' : r.no === 3 ? 'bg-background-300 text-foreground-800' : 'bg-background-200 text-foreground-500'
                }`}
              >
                {String(r.no).padStart(2, '0')}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <h3 className="font-heading text-base font-bold text-foreground-950 transition group-hover:text-primary-700 md:text-lg">
                    {r.title}
                  </h3>
                  <span className={`whitespace-nowrap rounded-sm px-2 py-0.5 text-[11px] font-bold ${statTone[r.stat]}`}>{r.stat}</span>
                </div>
                <p className="mt-1 text-xs text-foreground-500">
                  收录 <span className="font-bold text-foreground-700">{r.count}</span> 篇素材 · 累计阅读 <span className="font-bold text-foreground-700">{r.views}</span>
                </p>
              </div>
              <span className="inline-flex shrink-0 items-center justify-center gap-1 whitespace-nowrap rounded-md bg-background-50 px-4 py-2 text-sm font-bold text-foreground-700 ring-1 ring-background-200 transition group-hover:bg-primary-500 group-hover:text-background-50 sm:ml-auto">
                阅读盘点 <i className="ri-book-open-line flex h-4 w-4 items-center justify-center" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}